import { IProcedureLogs } from '@dataTypes/appointment.type'
import { IPhaseItems } from '@dataTypes/treatmentPlan.types'

/** Appointment form row: proc log fields plus linked catalog or TP item. */
export type AppointmentProcedureRow = Partial<IProcedureLogs> & {
  procedure?: unknown
}

/** Treatment plan item fee: persisted `charges` (incl. manual override), else catalog fee. */
export function resolveTxPlanItemClinicFee(item: IPhaseItems): number {
  const charges = Number(item.charges ?? 0)
  if (charges > 0) {
    return charges
  }
  return Number(
    item.procedure_settings?.procedure?.procedure_settings?.clinic_fee ??
      item.procedure_settings?.clinic_fee ??
      0,
  )
}

export function isTxPlanPhaseItem(
  procedure: unknown,
): procedure is IPhaseItems {
  return (
    typeof procedure === 'object' &&
    procedure !== null &&
    'item_id' in procedure &&
    'charges' in procedure
  )
}

/** Clinic fee for an appointment procedure row (catalog, TP item, or saved proc log). */
export function resolveAppointmentProcedureClinicFee(
  procedure: AppointmentProcedureRow,
): number {
  const linkedProcedure = procedure.procedure
  if (procedure.source === 3 && isTxPlanPhaseItem(linkedProcedure)) {
    return resolveTxPlanItemClinicFee(linkedProcedure)
  }
  if (procedure.clinic_fee != null) {
    return Number(procedure.clinic_fee)
  }
  const catalogProcedure = linkedProcedure as
    | { procedure_settings?: { clinic_fee?: number | string | null } }
    | undefined
  return Number(catalogProcedure?.procedure_settings?.clinic_fee ?? 0)
}
